module.exports = __webpack_public_path__ + "img/2021_2_7_white_face_monster.20cca7b5.jpg";